import React from 'react';
import {BroadcastList} from "../DummyData";

const Broadcast = () => {
    const [data, setData] = React.useState({
        messageContent: BroadcastList,
        selectedFilter: ''
    })

    const fetchMessage = async () => {
        await fetch(`${URL('public')}/security/oauth/check_token`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Basic ' + btoa('remarket:secret'),
            },
            body: JSON.stringify({
                filter: data.selectedFilter,
            })
        });
    }

    const selectFilter = (val) => {
        setData({
            ...data,
            selectedFilter: val
        })
        //TODO
        // fetchMessage();
        console.log('Passed Value :' + val)
    }

    return (
        <div className="container">
            <div className="broadcast-container">
                <div className="page-title">
                    Broadcast
                </div>
                <div className="line-space"/>
                <div className="broadcast-content">
                    <div className="broadcast-list">
                        <div className="list-header">
                            <div className="section-title">
                                Terkirim
                            </div>
                            <div>
                                <select className="list-search" name="filter" id="filter"
                                        onChange={e => selectFilter(e.target.value)}>
                                    <option value="">Semua</option>
                                    <option value="new">Kartu Baru</option>
                                    <option value="broke">Kartu Rusak</option>
                                    <option value="lost">Kartu Hilang</option>
                                </select>
                            </div>

                        </div>
                        <div className="line-space"/>
                        <div className="list-content-container">
                            {data.messageContent.map((item, index) => {
                                return (
                                    <div className="list-content">
                                        <div className="content-sent-type">{item.type}</div>
                                        <div
                                            className="content-sent-message">{item.message.substring(0, 200) + "..."}</div>
                                        <div className="line-space"/>
                                    </div>
                                )
                            })}
                        </div>

                    </div>
                    <div className="broadcast-message-box">
                        <div className="section-title">

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default Broadcast;
